import { theme } from '@qr-front/ui'
import { cn } from '@qr-front/ui/utils'
import { useAtomValue } from 'jotai'
import { ReactNode } from 'react'
import SimpleBar from 'simplebar-react'

import { PHONE_PREVIEW_OVERLAY_SLOT_ID } from '../../../components/PhonePreview'
import { isOverlayOpenAtom } from '../generatorState'
import { WelcomeImageOverlay } from './WelcomeImageOverlay'

export type TQrScreenProps = {
	previewMode: boolean
	demoMode: boolean
	overrideTopPadding?: number
}

export const QrScreen = ({
	previewMode,
	demoMode,
	overrideTopPadding,
	primaryColor,
	content,
}: TQrScreenProps & { content: ReactNode; primaryColor: string }) => {
	const isOverlayOpen = useAtomValue(isOverlayOpenAtom)
	const isPlainTextQrType = primaryColor === theme.colors['plain-text-bg']

	const screenRadius = previewMode ? '32px' : '0px'
    const overscrollBehavior = previewMode ? 'contain' : 'auto'
	const topBandHeight = overrideTopPadding ?? (previewMode ? 34 : 8)
	const topBandEnd = topBandHeight + 1
	const scrollContentBg = isPlainTextQrType
		? theme.colors['plain-text-bg']
		: `linear-gradient(to bottom, ${primaryColor} ${topBandEnd}px, white ${topBandEnd}px)`

	return (
		<>
			<style>{`
						.phone-preview-scroll-container, .phone-preview-scroll-container .simplebar-content {
							min-height: 100%;
						}
						
						.phone-preview-scroll-container .simplebar-wrapper,
						.phone-preview-scroll-container .simplebar-mask,
						.phone-preview-scroll-container .simplebar-offset,
						.phone-preview-scroll-container .simplebar-content-wrapper {
							border-radius: ${screenRadius};
						}
						
						.phone-preview-scroll-container .simplebar-content-wrapper {
							overscroll-behavior: ${overscrollBehavior};
						}

						.phone-preview-scroll-container .simplebar-track {
							margin-top: 38px !important;
							margin-bottom: 32px !important;
							margin-right: 2px !important;
							background-color: transparent !important;
						}
						
						.phone-preview-scroll-container .simplebar-scrollbar:before {
							background-color: ${theme.colors['border-grey']} !important;
						}
						`}</style>
			<SimpleBar
				autoHide
				style={{
					height: '100%',
					width: '100%',
					backgroundColor: isPlainTextQrType
						? theme.colors['plain-text-bg']
						: 'white',
					pointerEvents: isOverlayOpen ? 'none' : undefined,
				}}
				className={cn(
					'phone-preview-scroll-container',
					previewMode ? 'rounded-[32px]' : 'overflow-hidden',
				)}
			>
				<div
					className={cn(
						isPlainTextQrType && !previewMode
							? 'grid h-dvh'
							: 'h-full',
						demoMode && 'pointer-events-none',
					)}
					style={{
						paddingTop: topBandHeight,
						background: scrollContentBg,
					}}
				>
					{content}
				</div>
			</SimpleBar>
			<div
				className="z-2 pointer-events-none absolute left-0 right-0 top-0 w-full transition-colors"
				style={{
					height: topBandHeight,
					backgroundColor: primaryColor,
				}}
			/>
			<WelcomeImageOverlay
				previewMode={previewMode}
				demoMode={demoMode}
			/>
			{!previewMode ? <div id={PHONE_PREVIEW_OVERLAY_SLOT_ID} /> : null}
		</>
	)
}
